import { render } from "./SymbolMatching.vue?vue&type=template&id=6701ca86&scoped=true"
import script from "./SymbolMatching.vue?vue&type=script&lang=js"
export * from "./SymbolMatching.vue?vue&type=script&lang=js"

import "./SymbolMatching.vue?vue&type=style&index=0&id=6701ca86&scoped=true&lang=scss"

import exportComponent from "/var/www/mbp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6701ca86"]])

export default __exports__